import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import classNames from 'classnames';
import styles from '../../styles/main.scss';

// components
import Text from '../inputs/Text';

const messages = defineMessages({
    placeholder: {
        id: 'dc.CreditCardForm.CardHolderName.placeholder',
        defaultMessage: 'Name on Card*',
    },
});

const CardHolderName = ({
    value,
    autoFocus = false,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur = () => {},
    fullWidth = false,
}) => {
    const intl = useIntl();
    return (
        <Text
            name="cardHolderName"
            dataTn="billing-cardHolderName"
            value={value}
            wrapperClass={classNames(styles.left, {
                [styles.fullWidth]: fullWidth,
            })}
            placeholder={intl.formatMessage(messages.placeholder)}
            autoComplete="cc-name"
            autoFocus={autoFocus}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

CardHolderName.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    autoFocus: PropTypes.bool,
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    fullWidth: PropTypes.bool,
};

export default CardHolderName;
